import React from "react";
import DatePicker from "react-datepicker";
import { Box, Button, Text } from "@chakra-ui/react";
import { CalenderIcon } from "@root/assets/icons";
import { CloseIcon } from "@chakra-ui/icons";
import { formatDateToISO } from "@root/utils/date-helper";
interface CommonDateFieldProps {
  selectedDate: Date | null;
  onChange: (date: Date | null) => void;
  placeholder?: string;
  borderRadius?: string;
  borderColor?: string;
  color?: string;
  height?: string;
}

const CommonDateField: React.FC<CommonDateFieldProps> = ({
  selectedDate,
  onChange,
  placeholder = "",
  borderRadius = "full",
  borderColor = "#5C6670",
  color = "#5C6670",
  height = "fit-content",
}) => {
  return (
    <Box position="relative" display="inline-block">
      <DatePicker
        selected={selectedDate}
        onChange={onChange}
        placeholderText={placeholder}
        popperPlacement="bottom-end"
        customInput={
          <Button
            rightIcon={
              selectedDate ? (
                <CloseIcon
                  boxSize={3}
                  cursor="pointer"
                  onClick={(e) => {
                    e.stopPropagation();
                    onChange(null);
                  }}
                  data-testid="clear-date-icon"
                />
              ) : (
                <CalenderIcon />
              )
            }
            borderRadius={borderRadius}
            border="1px solid "
            borderColor={borderColor}
            bg="white"
            fontWeight="normal"
            width={"fit-content"}
            height={height}
            px={"16px"}
            py={"10px"}
            fontSize="14px"
            color={color}
          >
            {selectedDate ? (
              formatDateToISO(selectedDate)
            ) : (
              <Text>{placeholder}</Text>
            )}
          </Button>
        }
        calendarClassName="custom-datepicker"
      />
    </Box>
  );
};

export default CommonDateField;
